import * as types from '../../../actions/types';

const initialState = {
  mpid_stats: {},
  subjects_stats: {}
};

export default function ege (state = initialState, action) {
  switch (action.type) {
    case types.SET_DASHBOARD_DETAILS_EGE:
      return {...state, ...action.payload};

    default:
      return state;
  }
}
